var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadCloudSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.35 6.31344C18.67 2.86344 15.64 0.273438 12 0.273438C9.11 0.273438 6.6 1.91344 5.35 4.31344C2.34 4.63344 0 7.18344 0 10.2734C0 13.5834 2.69 16.2734 6 16.2734H19C21.76 16.2734 24 14.0334 24 11.2734C24 8.63344 21.95 6.49344 19.35 6.31344ZM19 14.2734H6C3.79 14.2734 2 12.4834 2 10.2734C2 8.22344 3.53 6.51344 5.56 6.30344L6.63 6.19344L7.13 5.24344C8.08 3.41344 9.94 2.27344 12 2.27344C14.62 2.27344 16.88 4.13344 17.39 6.70344L17.69 8.20344L19.22 8.31344C20.78 8.41344 22 9.72344 22 11.2734C22 12.9234 20.65 14.2734 19 14.2734ZM13.45 6.27344H10.55V9.27344H8L12 13.2734L16 9.27344H13.45V6.27344Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCloudSmallIcon);
export default __webpack_public_path__ + "static/media/DownloadCloudSmallIcon.cc1df779.svg";
export { ForwardRef as ReactComponent };